<template>

	<div>
		<input type="text" ref="inputelem" class="form-control no-border-radius"
			:placeholder="placeholder" 
			:value="value" 
			:class="[{'is-invalid': errorinfo.hasError}, inputclass]"
			:disabled="isProcessing"
			@input="$emit('input', $event.target.value)"/>
		<small class="error" v-if="errorinfo.hasError">{{errorinfo.msg}}</small>
	</div>

</template>

<script>
export default {
	props: {
		value: String,
		inputclass: String,
		placeholder: String,
		isProcessing: Boolean,
		focus: Boolean,
		errorinfo: {type: Object, default: () => ({})}
	},
	mounted() {
		if (this.focus) {
			this.$refs.inputelem.focus();
		}
	}
}
</script>
